/**
 * Calculates a price with handling fee and freight cost applied as percentages.
 * @param price - The base price
 * @param handlingFeeValue - Handling fee percentage (e.g. 5 = 5%)
 * @param freightCostValue - Freight cost percentage (e.g. 3 = 3%)
 */
export function priceWithFees(
  price: number,
  handlingFeeValue: number,
  freightCostValue: number,
): number {
  return price * (1 + handlingFeeValue / 100 + freightCostValue / 100);
}
